import * as React from 'react'
import Layout from '../components/layout'

const TermsPage = () => {
  return (
    <Layout
      pageTitle="Terms & Conditions"
      titleOverride="Terms & Conditions | Columbia Children's Center"
      metaDesc="Review the Terms & Conditions for Columbia Children's Center website and services."
      pathname="/terms/"
    >
      <a href="https://app.tryplayground.com/X7tvoDUHwazFjm1hgbal/book/j2qKHKe4akbD4Cv9DED7" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', marginBottom: '1rem', padding: '0.75rem 1.5rem', backgroundColor: '#007bff', color: '#fff', textDecoration: 'none', borderRadius: '0.375rem', fontWeight: 'bold' }}>Book a Tour</a>
      <div style={{ lineHeight: '1.8', color: '#333' }}>
        {/* <h2>Terms & Conditions</h2> */}
        
        <p><strong>Effective Date:</strong> April 17, 2026</p>
        <p><strong>Last Updated:</strong> April 17, 2026</p>

        <hr />

        <h3>Welcome</h3>
        <p>Welcome to Columbia Children's Center ("Company," "we," "us," or "our"). These Terms of Service ("Terms") describe the rules and conditions governing your use of our website located at <a href="https://columbiachildrenscenter.com">https://columbiachildrenscenter.com</a> (the "Site") and any services, tools, or communications offered by Columbia Children's Center.</p>

        <p>By visiting, accessing, or using the Site or our services, you agree to comply with and be legally bound by these Terms. If you do not agree to these Terms, you should stop using the Site immediately.</p>

        <hr />

        <h3>1. Eligibility</h3>
        <p>The Site and our services are intended for individuals who are 18 years of age or older. By accessing or using the Site, you represent that you are at least 18 years old and have the legal authority to enter into binding agreements.</p>

        <hr />

        <h3>2. Services Provided</h3>
        <p>Columbia Children's Center offers preschool, early childhood education, and child care services. We also offer enrollment information, program details, and inquiry services through our website and contact forms.</p>

        <p>Our services may include, but are not limited to:</p>
        <ul>
          <li>Preschool and child care programming</li>
          <li>Educational curriculum and activities</li>
          <li>Enrollment and application services</li>
          <li>Parent communication and resources</li>
          <li>Facility tours and program information</li>
        </ul>

        <p>We reserve the right to change, suspend, or discontinue any portion of our services at our discretion and without prior notice.</p>

        <hr />

        <h3>3. SMS Communications</h3>
        <p>If you provide your phone number and consent through our forms or other opt-in methods, you agree to receive SMS communications from Columbia Children's Center.</p>

        <p>These text messages may include:</p>
        <ul>
          <li>Responses to inquiries or consultation requests</li>
          <li>Appointment confirmations or reminders</li>
          <li>Information regarding services we provide</li>
          <li>Important program updates and information</li>
        </ul>

        <p>Message frequency may vary. Standard message and data rates may apply based on your mobile carrier.</p>

        <p><strong>You may unsubscribe from SMS communications at any time by replying:</strong></p>
        <p>STOP to opt out.<br />For help or support, reply HELP or contact us at:<br /><a href="mailto:info@columbiachildrenscenter.com">info@columbiachildrenscenter.com</a></p>

        <p>Mobile carriers are not responsible for messages that are delayed or not delivered.</p>

        <p>Phone numbers collected for SMS messaging will not be sold, rented, or shared with third parties or affiliates for marketing purposes.</p>

        <hr />

        <h3>4. Acceptable Use</h3>
        <p>You agree to use the Site and services only for lawful purposes and in accordance with these Terms.</p>

        <p>You agree not to:</p>
        <ul>
          <li>Attempt to access systems, servers, or data without authorization</li>
          <li>Interfere with or disrupt the operation of the Site</li>
          <li>Provide inaccurate or misleading information</li>
          <li>Use the Site or services in connection with unlawful or fraudulent activities</li>
        </ul>

        <hr />

        <h3>5. Intellectual Property</h3>
        <p>All materials available on the Site, including but not limited to:</p>
        <ul>
          <li>Text and written content</li>
          <li>Graphics and visual elements</li>
          <li>Logos and branding</li>
          <li>Marketing materials</li>
          <li>Software, code, and design components</li>
        </ul>

        <p>are owned by Columbia Children's Center or its licensors and are protected by applicable copyright, trademark, and intellectual property laws.</p>

        <p>You may not copy, reproduce, distribute, modify, or otherwise use any content from the Site without prior written authorization from Columbia Children's Center.</p>

        <hr />

        <h3>6. Third-Party Platforms and Services</h3>
        <p>The Site may include integrations with or links to third-party services, including but not limited to:</p>
        <ul>
          <li>Calendly (appointment scheduling)</li>
          <li>ProCare (enrollment management)</li>
          <li>Analytics services</li>
          <li>Advertising networks</li>
        </ul>

        <p>We do not control these third-party services and are not responsible for their privacy policies, practices, or actions.</p>

        <hr />

        <h3>7. Disclaimer of Warranties</h3>
        <p>The Site and services are provided on an "as is" and "as available" basis.</p>

        <p>We do not guarantee:</p>
        <ul>
          <li>The accuracy or completeness of information on the Site</li>
          <li>Continuous or uninterrupted availability of services</li>
          <li>That the Site will operate without errors or interruptions</li>
        </ul>

        <p>To the fullest extent permitted by law, Columbia Children's Center disclaims all warranties, whether express or implied.</p>

        <hr />

        <h3>8. Limitation of Liability</h3>
        <p>To the maximum extent permitted by applicable law, Columbia Children's Center will not be liable for any indirect, incidental, consequential, or special damages arising from or related to:</p>
        <ul>
          <li>Use of or inability to use the Site</li>
          <li>Interruptions in service</li>
          <li>Loss of data or information</li>
        </ul>

        <p>Your use of the Site and services is at your own risk.</p>

        <hr />

        <h3>9. Indemnification</h3>
        <p>You agree to defend, indemnify, and hold harmless Columbia Children's Center, along with its employees, contractors, partners, and affiliates, from any claims, damages, losses, liabilities, or expenses resulting from:</p>
        <ul>
          <li>Your use of the Site or services</li>
          <li>Your violation of these Terms</li>
          <li>Any unlawful or improper activity associated with your use of the Site</li>
        </ul>

        <hr />

        <h3>10. Termination</h3>
        <p>We reserve the right to suspend or terminate your access to the Site or our services at any time if we determine that you have violated these Terms or engaged in unlawful behavior.</p>

        <hr />

        <h3>11. Updates to These Terms</h3>
        <p>These Terms may be updated periodically. Any modifications will be posted on this page and will include a revised Last Updated date.</p>

        <p>Your continued use of the Site after changes are posted constitutes acceptance of the updated Terms.</p>

        <hr />

        <h3>12. Governing Law</h3>
        <p>These Terms are governed by and interpreted in accordance with the laws of the United States and applicable state laws, without regard to conflict of law rules.</p>

        <hr />

        <h3>13. Contact Information</h3>
        <p>If you have questions regarding these Terms of Service, please contact us:</p>

        <p>
          <strong>Columbia Children's Center</strong><br />
          Email: <a href="mailto:info@columbiachildrenscenter.com">info@columbiachildrenscenter.com</a><br />
          Website: <a href="https://columbiachildrenscenter.com">https://columbiachildrenscenter.com</a>
        </p>

        <hr />

        <p style={{ marginTop: '2rem', fontSize: '0.9rem', color: '#666' }}>
          <em>Last Updated: April 17, 2026</em>
        </p>
      </div>
    </Layout>
  )
}

export default TermsPage
